import React from 'react';
import CompanyRegistration from './CompanyRegistration';
import BusinessUnitRegistration from './BusinessUnitRegistration';

const steps = [
  {
    label: 'Cégregisztráció',
    component: <CompanyRegistration/>,
  },
  {
    label: 'Üzleti egység',
    component: <BusinessUnitRegistration/>,
  },
];

export default steps;